<ion-button fill="fill">
  <ion-badge mode="ios" color="danger" *ngIf="badgeText">{{badgeText}}</ion-badge>
  <ng-content></ng-content>
</ion-button>